 <div id="app" *ngIf="!isProdMode">
    <button type="button" hsg-button kind="primary" (click)="openLoginModal()">חלון הזדהות</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openIssueDateModal()">חלון תאריך הנפקה</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openAuthMethodModal()">חלון אופן זיהוי אישי</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openChangePasswordModal()">חלון החלפת סיסמה</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openCreditCardModal()">חלון אשראי</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openCustomerServiceModal()">חלון שירות לקוחות</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openEndprocessModal()">חלון סיום תהליך</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openPermanentpasswordeModal()">חלון סיסמה קבועה</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openActivationModal()">חלון אקטיבציה</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openValidateDetailsModal()">חלון בדיקת פרטים</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openOtpModal()">חלון Otp</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="closeOpenCallsModal()">סגירת פניות פתוחות</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openSuccessModal()">חלונית הצלחה</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openLoaderModal()">חלונית טעינה</button>
    <br>
    <button type="button" hsg-button kind="primary" (click)="openStrictIdChoice()">חלונית זיהוי בחירה (טאבים)</button>
</div>